import { awardStatuses } from '../../../utils/awardConstants';
import awardsApi from '../awards/awardsAPI';

export const awardCategoriesEndpoint = (franchiseId) =>
    `/site/api/trophy/trophy-categories/${franchiseId}` +
    `?cayenneExp=awardDetails.status='${awardStatuses.WINNER}'` +
    `&include=id` +
    `&include=name` +
    `&include=trophyCategory` +
    `&mapBy=trophyCategory.trophyRecipientCategory` +
    `&sort=trophyCategory`;

export const franchiseTrophyCategoriesEndpoint = '/site/api/trophy/franchise-trophy-categories';

export const awardsForFranchiseEndpoint = (franchiseId, { id, trophyRecipientCategory }) => {
    const trophyCategoryExp = id === 2 ? '&cayenneExp=trophyId != 1' : ''; // Removes every player who won the Stanley Cup, leaves teams
    return (
        `/site/api/award-details/${franchiseId}` +
        `?trophyCategoryId=${id}` +
        `${trophyCategoryExp}` +
        awardsApi.getAwardIncludes(trophyRecipientCategory) +
        `&include=trophy` +
        `&exclude=summary` +
        `&exclude=trophy.description` +
        `&sort=seasonId` +
        `&dir=DESC`
    );
};
